import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Flex, Box} from 'reflexbox';
import Button from 'components/Button';

import './tabs.styles.scss';

export default class Tabs extends Component {
    componentDidMount() {
        const { shoppingListView, setShoppingListView } = this.props;
        setShoppingListView(shoppingListView);
    }

    render() {
        const { shoppingListView, availableProducts, triggerShoppingListViewChange } = this.props;

        if (!availableProducts || !window.Checkout.settings.allow_add_to_bag || window.Checkout.settings.favourites.disable_tabs) {
            return null;
        }

        return (
            <div className="tabs">
                <Flex className="tabs-sleeve">
                    <Box className={`tabs__tab ${shoppingListView === 'buyonline' ? 'tabs__tab--active' : ''}`} w={1 / 2}>
                        <Button
                            text="tab_buy_online"
                            theme="unstyled"
                            onClick={triggerShoppingListViewChange.bind(this, 'buyonline')}
                        />
                    </Box>
                    <Box className={`tabs__tab ${shoppingListView === 'availableinstore' ? 'tabs__tab--active' : ''}`} w={1 / 2}>
                        <Button
                            text="tab_available_instore"
                            theme="unstyled"
                            onClick={triggerShoppingListViewChange.bind(this, 'availableinstore')}
                        />
                    </Box>
                </Flex>
            </div>
        );
    }
}

Tabs.propTypes = {
    list: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    shoppingListView: PropTypes.string.isRequired,
    setShoppingListView: PropTypes.func,
    availableProducts: PropTypes.bool,
    triggerShoppingListViewChange: PropTypes.func,
};
